import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from 'react-i18next';
import { Patient, SurveyPage } from '@quality24/inpatient-typings';
import { Button, Heading, Text } from '@quality24/design-system';
import { handlebarsCompiler } from '@/inpatient-patient-pwa/utils/handlebars';

export interface Props {
  page: Pick<SurveyPage, 'id' | 'titleI18N' | 'descriptionI18N' | 'data'>;
  patient?: Pick<Patient, 'name'> | null;
  onAnswer: () => void;
  onRefuse: () => void;
  onSkip: () => void;
}

const IntroductionPage: React.FunctionComponent<Props> = ({
  page,
  patient,
  onAnswer,
  onRefuse,
  onSkip,
}) => {
  const { t } = useTranslation();
  const description = page.descriptionI18N;

  const template = handlebarsCompiler(description);

  const htmlString = ReactHtmlParser(
    template({
      patient: patient?.name || t('common.patient'),
    }),
  );

  return (
    <>
      <Heading as="h1" weight="semiBold" size="lg1">
        {page.titleI18N}
      </Heading>
      <Text className="my-4" style={{ whiteSpace: 'pre-wrap' }}>
        {htmlString}
      </Text>

      <div className="d-flex flex-column gap-3">
        <Button size="lg" onClick={onAnswer} fluid>
          {t('dailySurvey.respondNow')}
        </Button>
        <Button variant="outline" size="lg" onClick={onSkip} fluid>
          {t('dailySurvey.respondLater')}
        </Button>
        <Button variant="link" size="lg" onClick={onRefuse} fluid>
          {t('dailySurvey.declineToAnswer')}
        </Button>
      </div>
    </>
  );
};

export default IntroductionPage;
